import CharacterNavItem from './CharacterNavItem';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import mapProps from 'recompose/mapProps';

const enhance = compose(
  mapProps(({ character, ...props }) => ({
    ...props,
    ...character,
    isDisabled: !!props.values.find(value => value.character === character.character),
  })),
  withHandlers({
    onChange: props => () => props.onChangeCharacter(props.characterIndex, props.letter, props.character)
  })
);

export default enhance(CharacterNavItem);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CharacterPicker/CharacterNav/CharacterNavItem/index.js